import React from 'react'
import {formatCurrency} from "../config/Util";

function WeekTotal({firstDate, lastDate, total, isDisabled}) {
    function setDays() {
        if (firstDate === undefined || lastDate === undefined)
            return

        let [, firstMonth, firstDay] = firstDate.split("-")
        let [, lastMonth, lastDay] = lastDate.split("-")

        return firstDay + '/' + firstMonth + ' - ' + lastDay + '/' + lastMonth
    }

    function setClassList() {
        let classes = ["week-total", "show-animation"]

        if (isDisabled) {
            classes.push("disabled")
        }

        return classes.join(" ")
    }

    return (
        <div className={setClassList()}>
            <div className="days">{setDays()}</div>
            <div className="total">{formatCurrency(total)}</div>
        </div>
    )
}

export default WeekTotal
